import React from "react";

const ITEMS = [
  "Vízvezeték-szerelés",
  "Csőtörés javítás",
  "Radiátorcsere",
  "Fűtésrendszerek",
  "WC-tartály csere",
  "Szivárgás bemérés",
  "Csaptelep csere",
  "Rendszer átmosás",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="bg-sky-600 py-4 overflow-hidden border-y border-sky-500/40">
      <div className="ss-marquee-track">
        {row.map((t, i) => (
          <span key={i} className="inline-flex items-center text-white/95 font-display font-bold text-lg tracking-tight">
            {t}
            <span className="mx-6 text-cyan-300">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
